import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  title,
  subtitle
`

export const fragment = (name = 'orderInquiryForm') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
